<script>

import {computed, ref} from "vue";

export function fieldColorCoding(field) {
  const colorCode = {
    Building: "rgba(246,205,205,0.5)",
    PED: "rgba(173,220,173,0.5)",
    PEB: "rgba(180,180,223,0.5)",
    City: "rgba(243,220,177,0.5)",
    Island: "rgba(89,56,112,0.5)"
  };
  return colorCode[field];
}

export const sectorPresenceRule = [
  (value) => {
  if (value.length !== 0) return true;
  return "You must select a Sector.";
}];

export const dimensionPresenceRule = [
  (value) => {
    if (value) return true;
    return "You must select a Dimension.";
}];

export const weightRule = [
    (value) => {
  if (value > 0 && value <= 1) return true;
  return "You must enter a number between 0 and 1.";
}];



</script>

<template>

</template>

<style scoped>

</style>
